// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2fRCp","approved":"Status_approved__1QcCp","rejected":"Status_rejected__hX-SE","expired":"Status_expired__aFViv","label":"Status_label__25Ec5"};